import React, { useState, useEffect } from "react";
import DashboardContainer from "../../../Dashboard_en/DashboardContainer";
import { motion } from "framer-motion";
import {
  
  
  
  
  
  Tooltip,
  
  
  
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import {
  
  Users,
  Eye,
  Image as ImageIcon,
  
  
  Activity,
} from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import ApiName from "../../../ApiName";

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalPaints: 0,
    totalViews: 0,
    totalImages: 0,
  });
  const [categoryData, setCategoryData] = useState([]);
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const statsResponse = await axios.get(ApiName + "/Dashboard/stats", {
        headers: { Authorization: localStorage.authToken },
      });

      setStats({
        totalPaints: statsResponse.data.totalPaints,
        totalViews: statsResponse.data.totalViews,
        totalImages: statsResponse.data.totalImages,
      });

      const categoriesResponse = await axios.get(ApiName + "/Dashboard/categories", {
        headers: { Authorization: localStorage.authToken },
      });
      setCategoryData(categoriesResponse.data);

      const activitiesResponse = await axios.get(ApiName + "/Dashboard/activities", {
        headers: { Authorization: localStorage.authToken },
      });
      setActivities(activitiesResponse.data);
    } catch (error) {
      console.error("Error loading dashboard data:", error);
    }
  };

  const COLORS = ["#6366f1", "#8b5cf6", "#ec4899", "#f59e0b"];

  const StatCard = ({ title, value, icon: Icon, trend, color }) => (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{title}</p>
          <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{value}</p>
          {trend && (
            <p className={`text-sm mt-2 flex items-center gap-1 ${trend > 0 ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"}`}>
              {trend > 0 ? "+" : ""}
              {trend}% from last month
            </p>
          )}
        </div>
        <div className={`p-4 rounded-full ${color}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </motion.div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, transition: { duration: 0.1 } }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.1 } }}
      className="w-full"
    >
      <DashboardContainer>
        <div className="p-6">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Dashboard Overview</h1>

          {/* Statistics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <StatCard
              title="Total Paints"
              value={stats.totalPaints}
              icon={ImageIcon}
              color="bg-indigo-500"
            />
            <StatCard
              title="Total Views"
              value={stats.totalViews.toLocaleString()}
              icon={Eye}
              color="bg-purple-500"
            />
            <StatCard
              title="Total Images"
              value={stats.totalImages}
              icon={ImageIcon}
              color="bg-pink-500"
            />
          </div>

          {/* Charts Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">


            {/* Pie Chart - Category Distribution */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Category Distribution
              </h3>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={categoryData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }) =>
                      `${name} ${(percent * 100).toFixed(0)}%`
                    }
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {categoryData.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Activity Feed */}
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700 h-[400px] overflow-y-auto">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                Recent Activity
              </h3>
              <div className="space-y-4">
                {activities.length === 0 ? (
                  <p className="text-gray-500 dark:text-gray-400">No recent activity.</p>
                ) : (
                  activities.map((activity) => (
                    <div key={activity.id} className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                      <div className="p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-full">
                        <Activity className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900 dark:text-white">
                          {activity.actionType}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {activity.description} - {new Date(activity.createdAt).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Quick Actions
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Link to="/admin/paints/add" className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg">
                <ImageIcon className="w-5 h-5" />
                Add New Paint
              </Link>
              <Link to="/admin/categories" className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all shadow-md hover:shadow-lg">
                <Users className="w-5 h-5" />
                Manage Categories
              </Link>
              <Link to="/admin/audit-logs" className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-pink-600 to-rose-600 text-white rounded-xl hover:from-pink-700 hover:to-rose-700 transition-all shadow-md hover:shadow-lg">
                <Activity className="w-5 h-5" />
                Audit Logs
              </Link>
            </div>
          </div>
        </div>
      </DashboardContainer>
    </motion.div>
  );
};

export default AdminDashboard;
